// src/components/WorkOrderCard.js

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box, IconButton, Menu, MenuItem, Chip, Divider, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // Hata burada düzeltildi
import VisibilityIcon from '@mui/icons-material/Visibility';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../context/AuthContext';
import { formatDistanceToNow, isPast } from 'date-fns';
import { tr } from 'date-fns/locale';

const WorkOrderCard = ({ workOrder, statuses, onStatusChange, onMarkAsDelivered }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentUser } = useAuth();
  const open = Boolean(anchorEl);
  const [kalanSure, setKalanSure] = useState('');

  useEffect(() => {
    if (workOrder && workOrder.teslimTarihi) {
        const teslimTarihiDate = workOrder.teslimTarihi.toDate();
        if (isPast(teslimTarihiDate) && workOrder.durum !== "Teslime Hazır" && workOrder.durum !== "Tamamlandı") {
            setKalanSure("Gecikti");
            return;
        }
        const sure = formatDistanceToNow(teslimTarihiDate, { addSuffix: true, locale: tr });
        setKalanSure(sure);
    }
  }, [workOrder]);

  const handleClick = (event) => { setAnchorEl(event.currentTarget); };
  const handleClose = () => { setAnchorEl(null); };
  const handleStatusSelect = (newStatus) => { onStatusChange(workOrder.id, newStatus); handleClose(); };

  const getActiveApplications = () => {
      const active = [];
      if (workOrder.uygulamalar?.camFilmi?.length > 0) active.push("Cam Filmi");
      if (workOrder.uygulamalar?.ppf?.length > 0) active.push("PPF Kaplama");
      if (workOrder.uygulamalar?.yikama?.aktif) active.push("Yıkama");
      if (workOrder.uygulamalar?.diger?.filter(h => h.aciklama).length > 0) active.push("Diğer");
      return active;
  };
  const activeApps = getActiveApplications();

  const getLogoPath = (markaModel) => {
      if (!markaModel) return '/logos/default.svg';
      const marka = markaModel.split(' ')[0].toLowerCase().replace(' ', '-');
      return `/logos/${marka}.svg`;
  };

  return (
    <Paper sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
            <Box sx={{ width: 60, height: 45, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', borderRadius: 1, p: 0.5 }}>
                <Box component="img" 
                    src={getLogoPath(workOrder.aracMarkaModel)}
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src='/logos/default.svg'; }}
                    alt={workOrder.aracPlaka} 
                    sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
                />
            </Box>
            <Box>
                <Typography variant="body2" fontWeight="bold">{workOrder.aracPlaka}</Typography>
                <Typography variant="caption" color="text.secondary">{workOrder.musteriAdSoyad}</Typography>
            </Box>
        </Box>
        <Box>
          <IconButton component={RouterLink} to={`/is-emri/${workOrder.id}`} size="small"><VisibilityIcon fontSize="small" /></IconButton>
          {currentUser?.role !== 'Usta' && (
            <>
              <IconButton size="small" onClick={handleClick}><MoreVertIcon fontSize="small" /></IconButton>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {statuses.filter(status => status !== workOrder.durum).map(status => (
                  <MenuItem key={status} onClick={() => handleStatusSelect(status)}>{status}'a Taşı</MenuItem>
                ))}
              </Menu>
            </>
          )}
        </Box>
      </Box>
      
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
          {activeApps.map(app => <Chip key={app} label={app} size="small" />)}
      </Box>

      <Divider sx={{ my: 0.5 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {currentUser && currentUser.role !== 'Usta' && (
             <Typography variant="body1" fontWeight="bold">
                {(workOrder.toplamTutar || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
             </Typography>
          )}
          <Box sx={{flexGrow: 1}} />
          <Typography variant="caption" color={kalanSure === "Gecikti" ? "error.main" : "text.secondary"} fontWeight="bold">
            {kalanSure}
          </Typography>
      </Box>
      {workOrder.durum === 'Teslime Hazır' && currentUser && currentUser.role !== 'Usta' && (
        <Button 
          variant="contained" 
          color="success" 
          size="small"
          startIcon={<CheckCircleIcon />}
          onClick={() => onMarkAsDelivered(workOrder.id)}
          sx={{ mt: 1 }}
        >
          Aracı Teslim Et
        </Button>
      )}
    </Paper>
  );
};

export default WorkOrderCard;
